// extracted by mini-css-extract-plugin
module.exports = {"root":"VariantTabPage_root__JWQuf","image_desc":"VariantTabPage_image_desc__4CWz9"};